import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var printMq = '@media print';
  return {
    position: _defineProperty({
      height: componentTheme.positionDimension,
      minWidth: componentTheme.positionDimension,
      marginLeft: '-1.2rem',
      marginRight: componentTheme.positionMargin,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: componentTheme.positionBackgroundColor,
      padding: "0 ".concat(componentTheme.positionPadding),
      zIndex: componentTheme.positionZIndex
    }, printMq, {
      colorAdjust: 'exact'
    }),
    positionText: {
      fontSize: componentTheme.positionTextFontSize,
      color: componentTheme.positionTextColor
    }
  };
};
export default generateStyle;